"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAAIRedirectionURL = exports.generateRedirectPathWithoutDeepLink = exports.formatEndpointURL = exports.findTripGtmTag = exports.findGtmTag = exports.findCarrierGtmTag = exports.fetchCode = exports.dropPaxToSnap = exports.createCookie = exports.constructPassengerData = exports.constructLocalStorageObject = exports.changeDateFormat = void 0;
exports.getCookie = getCookie;
exports.substituteValues = exports.isKiwiStation = exports.isCity = exports.getSNAPRedirection = exports.getRedirectionURL = exports.getOperatingAirline = exports.getListingAppQueryParameter = exports.getEndpointURL = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _dateFns = require("date-fns");

var _utilities2 = require("./PlacePickerCityGroupingWrapper/utilities");

var _constant = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var getEndpointURL = function getEndpointURL(config, id) {
  var data = config.find(function (ele) {
    return ele.id === id;
  });
  return data ? data.endpointUrl : null;
};

exports.getEndpointURL = getEndpointURL;

var formatEndpointURL = function formatEndpointURL(url, environment, domain) {
  var REPLACE_WITH = _constant.ENVIRONMENT_URL[environment];
  var subValue = domain || _constant.SUB_VALUE;
  return url.replace('{gcs_url}', REPLACE_WITH.GCS_URL).replace('{static_url}', REPLACE_WITH.STATIC_URL).replace('{feature_flag_env}', REPLACE_WITH.FEATURE_FLAG_ENV).replace('{kong_url}', environment === 'PRODUCTION' && _utilities.default.isChinaDomainName() ? REPLACE_WITH.KONG_URL_CN : REPLACE_WITH.KONG_URL).replace('{funnel_control_url}', REPLACE_WITH.FUNNEL_CONTROL_URL.replace('{domain}', subValue)).replace('{flights_api_url}', REPLACE_WITH.FLIGHTS_API_URL.replace('{domain}', subValue));
};

exports.formatEndpointURL = formatEndpointURL;

var getProviderValue = function getProviderValue(destination, provider) {
  // fetch from recent search
  if (destination && destination.provider) {
    return destination.provider;
  }

  if (destination.StationType === _constant.FILTER_TYPE.CITY_KEY && destination.Stations) {
    return (0, _utilities2.getProviderForCitySearch)(destination.Stations, provider);
  }

  return destination.Provider || provider;
}; // eslint-disable-next-line consistent-return


var getOperatingAirline = function getOperatingAirline(origin, destination, cityLevelGrouping) {
  var key = _constant.OPERATING_AIRLINE.KEY;
  var providerKey = _constant.OPERATING_AIRLINE.PROVIDER;

  if (cityLevelGrouping) {
    return getProviderValue(destination, _constant.AIRLINES.AAB);
  }

  if (!Object.prototype.hasOwnProperty.call(destination, providerKey) || destination[providerKey] === undefined) {
    // default in case Provider Key is not present - Safe check
    if ((!Object.prototype.hasOwnProperty.call(origin, key) || origin[key] === undefined) && (!Object.prototype.hasOwnProperty.call(destination, key) || destination[key] === undefined)) {
      return _constant.AIRLINES.AAB;
    }

    if (origin[key] && destination[key]) {
      return _constant.AIRLINES.AAB;
    }

    if (!origin[key] || !destination[key]) {
      return _constant.AIRLINES.FLYBEYOND;
    }
  } else if (destination[providerKey] === _constant.AIRLINES.AAI) {
    return _constant.AIRLINES.AAI;
  } else if (destination[providerKey] === _constant.AIRLINES.AAB) {
    return _constant.AIRLINES.AAB;
  } else if (destination[providerKey] === _constant.AIRLINES.FLYBEYOND) {
    return _constant.AIRLINES.FLYBEYOND;
  }
};

exports.getOperatingAirline = getOperatingAirline;

var getListingAppQueryParameter = function getListingAppQueryParameter(origin, destination, tripDates, tripType, passengers, promoCode, locale, currency, cabinClass, agentId) {
  var listingQueryParams = {};
  listingQueryParams.origin = origin.StationCode;
  listingQueryParams.destination = destination.StationCode;
  listingQueryParams.departDate = (0, _dateFns.format)(tripDates.departureDate, _constant.DATE_FORMAT.LISTING_DATE_FORMAT);

  if (tripType.toUpperCase() === _constant.TRIP_TYPES.RETURN) {
    listingQueryParams.returnDate = (0, _dateFns.format)(tripDates.returnDate, _constant.DATE_FORMAT.LISTING_DATE_FORMAT);
  }

  listingQueryParams.adult = passengers.adult;
  listingQueryParams.child = passengers.child;
  listingQueryParams.infant = passengers.infant;
  listingQueryParams.tripType = tripType.toUpperCase();
  listingQueryParams.locale = locale;
  listingQueryParams.currency = currency.toUpperCase();

  if (cabinClass && cabinClass.travelClass) {
    listingQueryParams.cabinClass = cabinClass.travelClass;
  }

  if (promoCode && promoCode.length > 0) {
    listingQueryParams.promoCode = promoCode;
  }

  if (agentId && agentId.length > 0) {
    listingQueryParams.custom1 = agentId;
  }

  return Object.keys(listingQueryParams).map(function (k) {
    return "".concat(k, "=").concat(listingQueryParams[k]);
  }).join('&');
};

exports.getListingAppQueryParameter = getListingAppQueryParameter;

var getAAIRedirectionURL = function getAAIRedirectionURL(originObj, destObj, dates, type, pax, promo, currency, environment) {
  var pathParameters = {
    '{origin}': originObj.StationCode,
    '{destination}': destObj.StationCode,
    '{departureDate}': (0, _dateFns.format)(dates.departureDate, _constant.DATE_FORMAT.AA_DATE_FORMAT),
    '{returnDate}': type.toUpperCase() === 'R' ? (0, _dateFns.format)(dates.returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT) : 'N',
    '{adult}': pax.adult,
    '{child}': pax.child,
    '{infant}': pax.infant,
    '{tripType}': type.toUpperCase() === 'R' ? 'R' : 'O',
    '{promoCode}': promo && promo.length > 0 ? promo : 'N',
    '{currency}': currency.toUpperCase(),
    '{sortType}': 'ST'
  };
  var query = Object.keys(pathParameters).map(function (k) {
    return pathParameters[k];
  }).join('/');
  return _constant.ENVIRONMENT_URL[environment].AAI_BASE_URL + query;
};

exports.getAAIRedirectionURL = getAAIRedirectionURL;

var getRedirectionURL = function getRedirectionURL(originObj, destObj, dates, type, pax, promo, environment, locale, currency, cabinClass, agentId) {
  return "".concat(_constant.ENVIRONMENT_URL[environment].LISTING_APP_URL, "?").concat(getListingAppQueryParameter(originObj, destObj, dates, type, pax, promo, locale, currency, cabinClass, agentId));
};

exports.getRedirectionURL = getRedirectionURL;

var substituteValues = function substituteValues(inputString, data) {
  return inputString.replace(/{[^{}]+}/g, function (match) {
    if (match in data) {
      return data[match];
    }

    return '';
  });
};

exports.substituteValues = substituteValues;

var generateRedirectPathWithoutDeepLink = function generateRedirectPathWithoutDeepLink(originObj, destObj, dates, type, pax, promo, locale, currency, environment) {
  var pathParameters = {
    '{locale}': locale.replace('-', '/'),
    '{origin}': originObj.StationCode,
    '{destination}': destObj.StationCode,
    '{adult}': pax.adult,
    '{child}': pax.child,
    '{infant}': pax.infant,
    '{promoCode}': promo && promo.length > 0 ? promo : 'N',
    '{currency}': currency.toUpperCase(),
    '{sortType}': 'ST'
  };
  var journeyDateObject = {};
  journeyDateObject['{departureDate}'] = (0, _dateFns.format)(dates.departureDate, _constant.DATE_FORMAT.AA_DATE_FORMAT);

  if (type.toUpperCase() === _constant.TRIP_TYPES.RETURN) {
    journeyDateObject['{tripType}'] = _constant.TRIP_TYPES.RETURN;
    journeyDateObject['{returnDate}'] = (0, _dateFns.format)(dates.returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT);
  } else {
    journeyDateObject['{tripType}'] = _constant.TRIP_TYPES.ONE_WAY;
    journeyDateObject['{returnDate}'] = 'N';
  }

  var finalObject = _objectSpread(_objectSpread({}, pathParameters), journeyDateObject);

  return substituteValues(_constant.ENVIRONMENT_URL[environment].AA_FLIGHT_SEARCH_PATH_PARAMETERS, finalObject);
};

exports.generateRedirectPathWithoutDeepLink = generateRedirectPathWithoutDeepLink;

var isKiwiStation = function isKiwiStation(station, key) {
  return !(!Object.prototype.hasOwnProperty.call(station, key) || station[key] === undefined || station[key]);
};

exports.isKiwiStation = isKiwiStation;

function getCookie(k) {
  var v = document.cookie.match("(^|;) ?".concat(k, "=([^;]*)(;|$)"));
  return v ? v[2] : null;
}

var createCookie = function createCookie(name, value, minutes) {
  var expires = '';

  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    expires = "; expires=".concat(date.toGMTString());
  }

  document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/; secure");
};

exports.createCookie = createCookie;

var isCity = function isCity(type) {
  return type === _constant.FILTER_TYPE.CITY_KEY;
};

exports.isCity = isCity;

var fetchCode = function fetchCode(data) {
  return isCity(data.StationType) ? data.CityCode : data.StationCode;
};

exports.fetchCode = fetchCode;

var constructLocalStorageObject = function constructLocalStorageObject(origin, destination, passengers, departDate, returnDate, promoCodeState, tripType, cityLevelGrouping) {
  var dateTime = new Date().toISOString();
  var originCode = fetchCode(origin);
  var destinationCode = fetchCode(destination); // sets value of provider on recent search for destination

  if (cityLevelGrouping && destination && destination.Stations) {
    destination.provider = (0, _utilities2.getProviderForCitySearch)(destination.Stations, _constant.AIRLINES.AAB);
  }

  var recentSearch = {
    route: {
      origin: originCode,
      destination: destinationCode,
      isOriginCity: cityLevelGrouping && isCity(origin.StationType),
      isDestinationCity: cityLevelGrouping && isCity(destination.StationType),
      originData: _utilities.default.removeObject(origin, _constant.STATIONS),
      destinationData: _utilities.default.removeObject(destination, _constant.STATIONS)
    },
    date: {
      depart: (0, _dateFns.format)(departDate, _constant.DATE_FORMAT.AA_DATE_FORMAT),
      return: returnDate ? (0, _dateFns.format)(returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT) : null
    },
    passengers: {
      adult: passengers.adult,
      children: passengers.child,
      infant: passengers.infant
    },
    tripType: tripType,
    created_at: dateTime,
    StationName: cityLevelGrouping && isCity(destination.StationType) ? destination.CityName : destination.StationName,
    DepartStationName: cityLevelGrouping && isCity(origin.StationType) ? origin.CityName : origin.StationName,
    IsDepartKiwiStation: isKiwiStation(origin, _constant.AA_FLIGHT),
    IsArrivalKiwiStation: isKiwiStation(destination, _constant.AA_FLIGHT),
    IsKiwiRoute: destination.Provider === _constant.AIRLINES.FLYBEYOND,
    promo: promoCodeState,
    originCountry: origin.CountryCode,
    destinationCountry: destination.CountryCode
  };

  if (!returnDate) {
    delete recentSearch.date.return;
  }

  var recentSearches = localStorage.getItem('recentSearches');
  var recentSearchesLength = cityLevelGrouping ? 8 : 20;

  if (recentSearches !== null) {
    var recentSearchesStructure = JSON.parse(decodeURIComponent(localStorage.getItem('recentSearches')));

    if (recentSearchesStructure.length === recentSearchesLength) {
      recentSearchesStructure.pop();
      recentSearchesStructure.unshift(recentSearch);
    } else {
      recentSearchesStructure.unshift(recentSearch);
    }

    localStorage.setItem('recentSearches', encodeURIComponent(JSON.stringify(recentSearchesStructure)));
  } else {
    var addRecentSearchItem = [];
    addRecentSearchItem.push(recentSearch);
    localStorage.setItem('recentSearches', encodeURIComponent(JSON.stringify(addRecentSearchItem)));
  }

  try {
    var newCookieFlightString = _constant.COOKIE_OBJECT_FLIGHT.replace('{origin}', originCode).replace('{destination}', destinationCode).replace('{originCountry}', origin.CountryCode).replace('{destinationCountry}', destination.CountryCode).replace('{StationName}', destination.StationName).replace('{DepartStationName}', origin.StationName).replace('{depart}', (0, _dateFns.format)(departDate, _constant.DATE_FORMAT.AA_DATE_FORMAT)).replace('{return}', returnDate ? (0, _dateFns.format)(returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT) : 'N').replace('{adult}', passengers.adult).replace('{children}', passengers.child).replace('{infant}', passengers.infant).replace('{tripType}', tripType).replace('{created_at}', dateTime).replace('{promo}', promoCodeState).replace('{IsDepartKiwiStation}', isKiwiStation(origin, 'AAFlight')).replace('{IsArrivalKiwiStation}', isKiwiStation(destination, 'AAFlight')).replace('{IsKiwiRoute}', destination.Provider === _constant.AIRLINES.FLYBEYOND);

    var flightRecentSearchCookie = getCookie('flightRecentSearch');

    if (flightRecentSearchCookie !== null) {
      var items = JSON.parse(getCookie('flightRecentSearch'));

      if (items.length >= 2) {
        items = items.slice(0, 2);
        items.pop();
        items.unshift(encodeURIComponent(newCookieFlightString));
      } else {
        items.unshift(encodeURIComponent(newCookieFlightString));
      }

      createCookie('flightRecentSearch', JSON.stringify(items), 10080);
    } else {
      var recentSearchList = [];
      recentSearchList.push(encodeURIComponent(newCookieFlightString));
      createCookie('flightRecentSearch', JSON.stringify(recentSearchList), 10080);
    }
  } catch (e) {// console.log('Error constructing cookie object for searched object', e);
  }
};

exports.constructLocalStorageObject = constructLocalStorageObject;

var constructPassengerData = function constructPassengerData(passengerData, translations, passengers) {
  var paxData = {};
  passengerData.forEach(function (pax) {
    if (Object.prototype.hasOwnProperty.call(pax, 'data')) {
      paxData.min = 1;
      paxData.max = 9;
    }

    if (Object.prototype.hasOwnProperty.call(pax, 'adult')) {
      var adult = {};
      adult.type = 'adult';
      adult.label = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.ADULT];
      adult.subLabel = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.ADULT_AGE_LIMIT];
      adult.min = 'infant';
      paxData.adult = adult;
    }

    if (Object.prototype.hasOwnProperty.call(pax, 'child')) {
      var child = {};
      child.type = 'child';
      child.label = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.CHILD];
      child.subLabel = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.CHILD_AGE_LIMIT];
      child.min = 0;
      paxData.child = child;
    }

    if (Object.prototype.hasOwnProperty.call(pax, 'infant')) {
      var infant = {};
      infant.type = 'infant';
      infant.label = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.INFANT];
      infant.subLabel = translations[0].data[0][_constant.PAX_TRANSLATION_KEYS.INFANT_AGE_LIMIT];
      infant.min = 0;
      infant.max = 'adult';
      paxData.infant = infant;
    }
  });
  return _objectSpread(_objectSpread({}, paxData), {
    passengerCount: passengers
  });
};

exports.constructPassengerData = constructPassengerData;

var dropPaxToSnap = function dropPaxToSnap(passengers) {
  var MAX_PAX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var pax = {
    adult: 0,
    child: 0,
    infant: 0
  };
  if (!passengers) return pax;
  var flightPax = passengers && passengers.adult + passengers.child + passengers.infant;
  if (flightPax <= MAX_PAX) return passengers;

  if (passengers.adult >= MAX_PAX) {
    pax.adult = MAX_PAX;
    return pax;
  }

  pax.adult = passengers.adult;

  if (passengers.child + passengers.adult <= MAX_PAX) {
    pax.child = passengers.child;
    if (passengers.infant + pax.adult + pax.child <= MAX_PAX) pax.infant = passengers.infant;else pax.infant = MAX_PAX - (pax.adult + pax.child);
  } else {
    pax.child = MAX_PAX - pax.adult;
    pax.infant = 0;
  }

  return pax;
};

exports.dropPaxToSnap = dropPaxToSnap;

var getSNAPRedirection = function getSNAPRedirection(props) {
  if (!props) return null;
  var currency = props.currency,
      locale = props.locale,
      environment = props.environment,
      destination = props.destination,
      passengers = props.passengers,
      origin = props.origin,
      tripDates = props.tripDates,
      promoCode = props.promoCode;
  if (!destination || !origin || !passengers || !tripDates) return null;
  var listingQueryParams = {};
  var passengerObj = dropPaxToSnap(passengers, _constant.SNAP_DATA.MAX_PASSENGERS);
  var children = [];
  var infants = [];

  for (var i = 0; i < (passengerObj.child || 0); i++) {
    children.push(_constant.SNAP_DATA.CHILD_AGE_DEFAULT);
  }

  for (var _i = 0; _i < (passengerObj.infant || 0); _i++) {
    infants.push(_constant.SNAP_DATA.INFANT_AGE_DEFAULT);
  }

  listingQueryParams.orig = origin.StationCode;
  listingQueryParams.dest = destination.StationCode;
  listingQueryParams.fromDateFlight = (0, _dateFns.format)(tripDates.departureDate, _constant.DATE_FORMAT.AA_DATE_FORMAT);
  listingQueryParams.toDateFlight = (0, _dateFns.format)(tripDates.returnDate, _constant.DATE_FORMAT.AA_DATE_FORMAT);
  listingQueryParams.adults = passengerObj.adult;
  if (children.length > 0) listingQueryParams.children = children;
  if (infants.length > 0) listingQueryParams.infants = infants;
  listingQueryParams.language = locale;
  listingQueryParams.currency = currency.toUpperCase();
  listingQueryParams.rooms = 1;

  if (promoCode.length > 0) {
    listingQueryParams.promoCode = promoCode;
  }

  var queryParams = Object.keys(listingQueryParams).map(function (k) {
    return "".concat(k, "=").concat(listingQueryParams[k]);
  }).join('&');
  var url = "".concat(_constant.ENVIRONMENT_URL[environment].AA_BASE_URL).concat(_constant.ENVIRONMENT_URL[environment].SNAP_URL, "?").concat(queryParams);
  return url;
};

exports.getSNAPRedirection = getSNAPRedirection;

var findGtmTag = function findGtmTag(val) {
  if (val === _constant.STATION_ICONS.RECENT_SEARCH_ICON) return _constant.GTM_TAGS.RECENT_SEARCHES;
  if (val === _constant.STATION_ICONS.LOCATION_ON_ICON) return _constant.GTM_TAGS.NEAREST_AIRPORT;
  return _constant.GTM_TAGS.GENERAL;
};

exports.findGtmTag = findGtmTag;

var findCarrierGtmTag = function findCarrierGtmTag(val) {
  return val === _constant.AIRLINES.OTA || val === _constant.AIRLINES.FLYBEYOND ? val.toLowerCase() : _constant.GTM_TAGS.FLIGHTS;
};

exports.findCarrierGtmTag = findCarrierGtmTag;

var findTripGtmTag = function findTripGtmTag(val) {
  return val === _constant.TRIP_TYPES.RETURN ? _constant.GTM_TAGS.RETURN : _constant.GTM_TAGS.ONEWAY;
};

exports.findTripGtmTag = findTripGtmTag;

var changeDateFormat = function changeDateFormat(date) {
  var dateSpilts = date.toLocaleDateString().split('/');
  return dateSpilts.length === 3 ? "".concat(dateSpilts[2], "-").concat(dateSpilts[1], "-").concat(dateSpilts[0]) : '';
};

exports.changeDateFormat = changeDateFormat;